import { primaryColor } from './base'

export const tableHeaderBg = 'white'
export const tableFooterBg = 'white'
export const tableHeaderColor = primaryColor
export const tableRowHoverBg = '#F8F9FC'
